import { render, staticRenderFns } from "./TEMPLATE.vue?vue&type=template&id=5797aaf6&"
import script from "./TEMPLATE.vue?vue&type=script&lang=js&"
export * from "./TEMPLATE.vue?vue&type=script&lang=js&"
import style0 from "./TEMPLATE.vue?vue&type=style&index=0&id=5797aaf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports